__webpack_require__.p = "/h5/jh/ktg/dist/";